import { useState, useEffect } from "react";

const useMousePosition = () => {
  const [mousePosition, setMousePosition] = useState({ x: null, y: null });

  const updateMousePosition = (e) => {
    setMousePosition({ x: e.clientX, y: e.clientY });
  };

  useEffect(() => {
    window.addEventListener("mousedown", updateMousePosition);

    return () => {
      window.removeEventListener("mousedown", updateMousePosition);
    };
  }, []);

  return mousePosition;
};

export default useMousePosition;
